import { clsx } from 'clsx';
import { useSidebar } from "../../sidebar-context";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(_ref) {
  var module = _ref.module;
  var _useSidebar = useSidebar(),
    sidebarCollapsed = _useSidebar.sidebarCollapsed;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (sidebarCollapsed) return null;
  var label = module.label,
    Icon = module.icon,
    _module$accentedColor = module.accentedColor,
    accentedColor = _module$accentedColor === void 0 ? true : _module$accentedColor;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('tw-flex tw-pt-2 tw-pb-1.6 tw-px-1.2 tw-items-center '),
    children: [Icon && /*#__PURE__*/_jsx("div", {
      className: "tw-w-[40px] tw-h-[40px] tw-rounded-[6px] tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01 tw-flex tw-items-center tw-justify-center tw-border-solid tw-border-[0.5px] dark:tw-border-elevation-dark-04  tw-border-neutral-light-400 ",
      children: /*#__PURE__*/_jsx(Icon, {
        size: 24,
        className: clsx(accentedColor ? 'tw-text-primary-light-500 dark:tw-text-neutral-dark-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500')
      })
    }), /*#__PURE__*/_jsx("p", {
      className: "tw-font-subtitle4 tw-text-neutral-light-800 dark:tw-text-neutral-dark-400 tw-ml-1.2",
      children: label
    })]
  });
};